// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rmGlm","name":"styles_name__1Aeoo","phone":"styles_phone__7cVeN"};